import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '@praxis/component-auth';
import { Layout, Grid, Button, TargetLogo, Heading, Dropdown, Avatar } from '@enterprise-ui/canvas-ui-react';
import EnterpriseIcon, { MenuIcon } from '@enterprise-ui/icons';

// eslint-disable-next-line no-unused-vars
var getInitials = function getInitials(userInfo) {
  return "".concat(userInfo.firstName.charAt(0)).concat(userInfo.lastName.charAt(0));
};
var AppHeader = function AppHeader(_ref) {
  var appName = _ref.appName,
    onSideNavOpen = _ref.onSideNavOpen;
  var auth = useAuth();
  var logout = auth.logout,
    session = auth.session;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Layout.Header, {
    className: "topPage-layout-header"
  }, /*#__PURE__*/React.createElement(Grid.Container, {
    spacing: "dense"
  }, /*#__PURE__*/React.createElement(Grid.Item, null, /*#__PURE__*/React.createElement(Button, {
    className: "C-MenuButton header-icon-button",
    onClick: onSideNavOpen,
    iconOnly: true,
    "data-testid": "headerMenuButton",
    "aria-label": "open side nav menu"
  }, /*#__PURE__*/React.createElement(EnterpriseIcon, {
    icon: MenuIcon,
    size: "lg"
  }))), /*#__PURE__*/React.createElement(Grid.Item, null, /*#__PURE__*/React.createElement(Link, {
    to: "/"
  }, /*#__PURE__*/React.createElement(TargetLogo, {
    size: "expanded",
    color: "white"
  }))), /*#__PURE__*/React.createElement(Grid.Item, null, /*#__PURE__*/React.createElement(Link, {
    to: "/"
  }, /*#__PURE__*/React.createElement(Heading, {
    size: 4,
    className: "white-header"
  }, appName))))), /*#__PURE__*/React.createElement(Layout.GlobalActions, null, /*#__PURE__*/React.createElement(Grid.Container, {
    justify: "flex-end"
  }, /*#__PURE__*/React.createElement(Grid.Item, null, /*#__PURE__*/React.createElement(Dropdown, {
    size: "dense",
    location: "bottom-right"
  }, /*#__PURE__*/React.createElement(Button, {
    "aria-label": "Click to open dropdown menu",
    iconOnly: true,
    className: "praxcss-avatarButton",
    "data-testid": "headerGlobalActionsButton"
  }, /*#__PURE__*/React.createElement(Avatar, {
    "aria-label": "Avatar showing the initials for ".concat(session.userInfo.fullName)
  }, getInitials(session.userInfo))), /*#__PURE__*/React.createElement(Dropdown.Menu, null, /*#__PURE__*/React.createElement(Dropdown.MenuItem, {
    "data-testid": "headerLogoutButton",
    onClick: logout
  }, "Log Out")))))));
};

export { AppHeader as default };
